import React from "react";
import { Button, Icon, Result } from "antd";
import get from "lodash/get";
import { Link } from "react-router-dom";

import mapped_statuses from "../../data/mappedStatus";
import { withNamespaces } from "react-i18next";

const ValidationFormStep4Component = (props) => {
  if (props.currentStep !== "Step 4") {
    return null;
  }
  return (
    <div className="form-group">
      <Result
        status="success"
        title={props.i18n.t(
          "NamespaceValidateRandomizationStep4:Confirmation - Validation has been recorded!"
        )}
        subTitle={
          <div>
            <b style={{ fontSize: "15px" }}>{props.i18n.t("Site ID")}:</b>{" "}
            <span
              style={{ color: "var(--primary-color)", display: "inline-block" }}
            >
              {props.siteID}
            </span>
            <br />
            <b style={{ fontSize: "15px" }}>{props.i18n.t("User ID")}:</b>{" "}
            <span
              style={{ color: "var(--primary-color)", display: "inline-block" }}
            >
              {props.userID}
            </span>
            <br />
            <b style={{ fontSize: "15px" }}>
              {props.i18n.t("Subject ID")}:
            </b>{" "}
            <span
              style={{ color: "var(--primary-color)", display: "inline-block" }}
            >
              {props.subjectID}
            </span>
            <br />
            <br />
            <div className="validation-exists">
              <hr />
              <p> </p>
              <h5 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Randomization Information")}
              </h5>

              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Randomization Date")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.randomizationDate}
                </span>
              </h6>
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Name")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {get(props, "subject.profile.first_name")}{" "}
                  {get(props, "subject.profile.last_name")}
                </span>
              </h6>
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Email")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {get(props, "subject.profile.email")}
                </span>
              </h6>
              {!!get(props, "subject.drug.vial_number") && (
                <h6 style={{ display: "inline-block !important" }}>
                  {props.i18n.t("Drug #")}:{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      display: "inline-block",
                    }}
                  >
                    {get(props, "subject.drug.vial_number")}
                  </span>
                </h6>
              )}
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Drug Status")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {mapped_statuses(props.i18n)[get(props, "subject.drug.drug_status")]}
                </span>
              </h6>
              <p> </p>
              <h5 style={{ display: "inline-block !important" }}>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep4:Validation Information"
                )}
              </h5>

              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Validation Date")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationExistsDate}
                </span>
              </h6>
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep4:Has The Patient Received The Assigned Drug Bottle?"
                )}
                :{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationExistsUsedRecommendedValues === true ? (
                    <div>{props.i18n.t("Yes")}</div>
                  ) : (
                    <div>{props.i18n.t("No")}</div>
                  )}
                </span>
              </h6>
              {!!(
                props.validationExistsUsedRecommendedValues === false &&
                get(props, "subject.drug.vial_number")
              ) ? (
                <h6 style={{ display: "inline-block !important" }}>
                  {props.i18n.t("Expected drug #")}:{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      display: "inline-block",
                    }}
                  >
                    {get(props, "subject.drug.vial_number")}
                  </span>
                </h6>
              ) : get(props, "subject.drug.vial_number") ? (
                <h6 style={{ display: "inline-block !important" }}>
                  {props.i18n.t("Drug #")}:{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      display: "inline-block",
                    }}
                  >
                    {get(props, "subject.drug.vial_number")}
                  </span>
                </h6>
              ) : (
                <div />
              )}

              {!!(
                props.validationExistsUsedRecommendedValues === false &&
                props.actualUsedBottle
              ) ? (
                <h6 style={{ display: "inline-block !important" }}>
                  {props.i18n.t(
                    "NamespaceValidateRandomizationStep4:Actual used drug #"
                  )}
                  :{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      display: "inline-block",
                    }}
                  >
                    {props.actualUsedBottle}
                  </span>
                </h6>
              ) : null}

              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep4:Validation Comments"
                )}
                :{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationExistsComments}
                </span>
              </h6>

              <hr />
              <p> </p>
              <h5 style={{ display: "inline-block !important" }}>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep4:Deviation Details"
                )}
              </h5>
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t(
                  "NamespaceValidateRandomizationStep4:Has the drug been returned by the patient? Or have any other protocol deviations occurred?"
                )}{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationExistsDeviationOccurred === true ? (
                    <div>{props.i18n.t("Yes")}</div>
                  ) : (
                    <div>{props.i18n.t("No")}</div>
                  )}
                </span>
              </h6>
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Deviation Comments")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationDeviationExistsComments}
                </span>
              </h6>

              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Has the patient died?")}{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationPatientDied === true ? (
                    <div>{props.i18n.t("Yes")}</div>
                  ) : (
                    <div>{props.i18n.t("No")}</div>
                  )}
                </span>
              </h6>

              {props.validationPatientDied === true ? (
                <h6 style={{ display: "inline-block !important" }}>
                  {props.i18n.t(
                    "NamespaceValidateRandomizationStep4:Patient Deceased Date"
                  )}
                  :{" "}
                  <span
                    style={{
                      color: "var(--primary-color)",
                      display: "inline-block",
                    }}
                  >
                    {props.validationPatientDiedDate}
                  </span>
                </h6>
              ) : null}
              <h6 style={{ display: "inline-block !important" }}>
                {props.i18n.t("Deviation Comments")}:{" "}
                <span
                  style={{
                    color: "var(--primary-color)",
                    display: "inline-block",
                  }}
                >
                  {props.validationPatientDiedComments}
                </span>
              </h6>

              <p>
                <Link to="/admin/validation/list">
                  <Button>
                    <Icon type="arrow-left" />
                    {props.i18n.t("Back")}
                  </Button>
                </Link>
              </p>
              {/* <hr />
                  <p> </p>
                  <h5 style={{  display: 'inline-block !important' }}>Vial Information</h5>

                  <h6 style={{  display: 'inline-block !important' }}>Vial Number: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsVialNumber}</span></h6>
                  <h6 style={{  display: 'inline-block !important' }}>Vial Expiry Date: <span style={{ color: 'var(--primary-color)', display: 'inline-block' }}>{props.validationExistsVialExpiryDate}</span></h6> */}
            </div>
          </div>
        }
      />
    </div>
  );
};

export const ValidationFormStep4 = withNamespaces()(
  ValidationFormStep4Component
);



// WEBPACK FOOTER //
// ./src/components/ValidateRandomization/ValidateRandomizationStep4.js